<script setup lang="ts">
import GraveDetailPage from "@/components/graveyard/GraveDetailPage.vue";

definePage({
  meta: {
    navActiveLink: "graveyard-graves",
    permissionKey: "page.graveyard.graves",
  },
});

const route = useRoute();
const recordId = computed(() => String((route.params as Record<string, unknown>).id || ""));
</script>

<template>
  <GraveDetailPage :record-id="recordId" />
</template>
